module.exports = " <div class=container-fluid _v-534ea392=\"\"> <div class=classification--stars _v-534ea392=\"\"> <img src=/images/offes-news-img/stars-orange.png _v-534ea392=\"\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-534ea392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/elements/classification-stars.vue
// module id = 423
// module chunks = 0